import React, { useEffect, useState, useLayoutEffect } from "react";
import { Row, Col } from "react-bootstrap"
import FilterReport from "./header/FilterReport"
import styles from "./style.module.css"
import { Tag } from "rsuite"
import { format, startOfMonth } from "date-fns"
import axiosService from "../../utils/axios.service";
import {axiosServiceFormData} from "../../utils/axios.service";
import { Bar } from '@ant-design/plots';
import "./scss/report.scss"
import { Table, Spin } from 'antd';
import async from "async"
import 'antd/dist/antd.min.css'
import StorageService from "../../utils/storage.service";
import PopupViewServices from "./PopupViewServices"
import { Tooltip } from "antd";
import { iteratee } from "lodash";


const ReportKtvTvvOffline = () => {
    const [title, setTitle] = useState("Báo cáo tư vấn & phục vụ offline")
    const [startDate, setStartDate] = useState(format(new Date(startOfMonth(new Date())), "yyyy-MM-dd"))
    const [endDate, setEndDate] = useState(format(new Date(), 'yyyy-MM-dd'))
    const [store, setStore] = useState(
        (JSON.parse(StorageService.getItem("user_info")) && JSON.parse(StorageService.getItem("user_info")).role == 3) ?
            JSON.parse(StorageService.getItem("user_info")).stores[0].id
        : parseInt(StorageService.getItem("currentStore")) )
    const [isExport, setIsExport] = useState(false)
    const [loading, setLoading] = useState(true);
    const [isView, setIsView] = useState(false);

    const [dataViewService, setDataViewService] = useState([])
    const [chart, setChart] = useState([])

    const [keyword, setKeyword] = useState([])

    const [userAdmin, setUserAdmin] = useState(JSON.parse(StorageService.getItem("user_info")))
    const [pageSize, setPageSize] = useState(10)
    const [fileUp, setFile]  = useState(null)

    const [totalComPv, setTotalComPv] = useState(0)
    const [totalPaidTv, setTotalPaidTv] = useState(0)
    const [totalComTv, setTotalComTv] = useState(0);
    const [totalOrderPv, setTotalOrderPv] = useState(0)
    const [totalOrderTv, setTotalOrderTv] = useState(0)
    const [aov, setAov] = useState(0)
    const [table, setTable] = useState([])
    const [detailComPv, setDetailComPv] = useState(0)

    useEffect(() => {
        setTitle("Báo cáo tư vấn & phục vụ offline")
    }, [])
    const handleRangeDate = (sDate, eDate) => {
        setStartDate(sDate)
        setEndDate(eDate)
    }
    const handleStore = (x) => {
        setStore(x)
    }
    const fetchData = async (sD, eD, s) => {
        const { data } = await async.parallel({
            data: (cb) => {
                axiosService(`api/mysql/report-offline-ktv-lt/all?start=${sD}&end=${eD}&store=${store}&keyword=${keyword}`, "GET").then(rs => {
                    const { data } = rs
                    cb(null, data)
                })
            }
        })
        if (data.code === 200) {
            setLoading(false)
            const {totalComPv, totalPaidTv, totalComTv, totalOrderPv, totalOrderTv, aov, dataTable} = data.data

            setTotalComPv(totalComPv)
            setTotalPaidTv(totalPaidTv)
            setTotalComTv(totalComTv)
            setTotalOrderPv(totalOrderPv)
            setTotalOrderTv(totalOrderTv)
            setAov(aov)
            setTable(dataTable)
        }

    }
    useLayoutEffect(() => {
        setLoading(true)
        fetchData(startDate, endDate, store)
    }, [startDate, endDate, store, keyword])

    const config = {
        data: chart,
        isStack: true,
        xField: 'value',
        yField: 'name',
        seriesField: 'type',
        label: false,
        xAxis: {
            label: {
                formatter: (v) => `${v}`.replace(/\d{1,3}(?=(\d{3})+$)/g, (s) => `${s},`),
            },
        },
        tooltip: {
            formatter: (data) => {
                return {
                    name: data.name,
                    value: convertCurrency(data.value)
                };
            },
        }
    };
    function convertCurrency(data) {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };
    
    const showPopupViewService = (service, com_pv) => {
        setIsView(!isView)
        setDataViewService(service)
        setDetailComPv(com_pv)
    }

    const handleIsView = (e) => {
        setIsView(!isView)
    }
    const columns = [
        {
            title: 'Nhân viên',
            dataIndex: 'users_name',
            width: 250,
            fixed: 'left',
            render: (data) => {
                return (
                    <p style={{fontWeight: 'bold'}} >{data}</p>
                )
            }
        },
        {
            title: <Tooltip className="show-tooltip" title='Chi tiết số lượng dịch vụ của kỹ thuật viên phục vụ khách hàng.'> Dịch vụ phục vụ <i className="fas fa-info-circle"></i></Tooltip>,
            width: 250,
            render: (data) => {
                return (
                    data?.services.length > 0 ?
                        <p className="text_service" onClick={() => showPopupViewService(data.services, (data.com_pv ?? 0))}>Xem chi tiết phục vụ ...</p>
                    : 
                        <p className="text_service_none">Không có dịch vụ phục vụ</p>
                )
            },
        },
        {
            title: 'Thưởng phục vụ',
            dataIndex: 'com_pv',
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(Number(data))}</p>
                )
            },
            sorter: {
                compare: (a, b) => Number(a.com_pv) - Number(b.com_pv)
            },
        },
        {
            title: 'Thưởng tư vấn',
            dataIndex: 'com_tv',
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(Number(data))}</p>
                )
            },
            sorter: {
                compare: (a, b) => Number(a.com_tv) - Number(b.com_tv)
            },
        },
        {
            title: <Tooltip className="show-tooltip" title='Số tiền cần thu sau khi đã trừ các khoản giảm trừ bao gồm: giảm giá, chiết khấu, thuế (nếu có). Từ nguồn Offline.'>
                Doanh số thuần tư vấn <i className="fas fa-info-circle"></i>
            </Tooltip>,
            dataIndex: 'total_price_order',
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(Number(data))}</p>
                )
            },
            sorter: {
                compare: (a, b) => Number(a.total_price_order) - Number(b.total_price_order)
            },
        },
        {
            title: <Tooltip className="show-tooltip" title='Tổng số tiền thực tế đã thu được từ các đơn hàng đến từ nguồn Offline bằng các phương thức thanh toán chuyển khoản, tiền mặt, quẹt thẻ, sử dụng tiền trong tài khoản, không bao gồm sử dụng điểm tích lũy.'>
                Thực thu bán hàng <i className="fas fa-info-circle"></i>
            </Tooltip>,
            dataIndex: 'paid_order',
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(Number(data))}</p>
                )
            },
            sorter: {
                compare: (a, b) => Number(a.paid_order) - Number(b.paid_order)
            },
        },
        {
            title: 'Tỷ lệ chốt',
            align: "center",
            render: (t,data) => {
                return (
                    <div>
                        <p className="text1">Tổng khách phục vụ: {data.count_order_pv}</p>
                        <p className="text2">Tổng khách tư vấn: {data.count_order_tv}</p>
                        <p className="text3">Tỉ lệ: {data.aov} %</p>
                    </div>
                )
            },
        },
        {
            title: 'Tỷ lệ chốt khách mới',
            align: "center",
            render: (t,data) => {
                return (
                    <div>
                        <p className="text1">Tổng khách phục vụ: {data.count_new_pv}</p>
                        <p className="text2">Tổng khách tư vấn: {data.count_new_tv}</p>
                        <p className="text3">Tỉ lệ: {data.aov_new} %</p>
                    </div>
                )
            },
        },
        {
            title: 'Tỷ lệ chốt khách cũ',
            align: "center",
            render: (t,data) => {
                return (
                    <div>
                        <p className="text1">Tổng khách phục vụ: {data.count_old_pv}</p>
                        <p className="text2">Tổng khách tư vấn: {data.count_old_tv}</p>
                        <p className="text3">Tỉ lệ: {data.aov_old} %</p>
                    </div>
                )
            },
        }
    ];

    const handleExportData = async () => {
        setLoading(true);
        try {
            const header = {
                users_name: "Nhân viên",
                com_pv: "Thưởng phục vụ",
                com_tv: "Thưởng tư vấn",
                paid_order: "Số tiền thực thu",
                count_order_pv: "Số khách phục vụ",
                count_order_tv: "Số khách tư vấn",
                aov: "Aov",
                aov_new: "Aov khách mới",
                aov_old: "Aov khách cũ",
            };
            const rows = [
                Object.values(header),
                ...table.map((x) => [
                    x.users_name,
                    x.com_pv,
                    x.com_tv,
                    x.paid_order,
                    x.count_order_pv,
                    x.count_order_tv,
                    x.aov,
                    x.aov_new,
                    x.aov_old,
                ]),
            ];
            const payload = {
                name: "tu-van-va-phuc-vu-offline",
                sheets: [{ name: "Tư vấn và phục vụ", data: rows }],
            };
            const resExport = await axiosService(
                "api/mysql/export/have-data",
                "POST",
                payload,
            );
            if (resExport.data.code === 200 && resExport.data.data?.url) {
                window.open(resExport.data.data.url, "_blank");
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    
    const onChangeKeyword = (e) => {
        setKeyword(e)
    }
    const  handleChange = (e) => {
        setPageSize(e.pageSize)
    }

    

    const handleChangeFile = async (e) => {
        setFile(e.target.files[0])
    }
    
    const onFileUpload = async () => {
        const formData = new FormData();
        formData.append(
            "file",
            fileUp,
            fileUp.name
        );
        
        let res = await axiosServiceFormData("api/employee", "POST", formData)
    };

    return (

        <>
            <div className={`container-fluid ${styles.background}`}>
                <FilterReport startDate={startDate} endDate={endDate}
                    handleRangeDate={handleRangeDate} store={store}
                    handleStore={handleStore}
                    title={title} type={"ktv-tvv"}
                    csvData={table} isExport={isExport}
                    handleExportData={handleExportData}
                    onChangeKeyword={onChangeKeyword}
                    header={
                        [
                            { label: 'Nhân viên', key: "users_name" },
                            { label: "Thưởng phục vụ", key: "com_pv" },
                            { label: "Thưởng tư vấn", key: "com_tv" },
                            { label: "Số tiền thực thu", key: "paid_order" },
                            { label: "Đơn phục vụ", key: "count_order_pv" },
                            { label: "Đơn tư vấn", key: "count_order_tv" },
                            { label: "Aov", key: "aov" },
                            { label: "Aov khách cũ", key: "aov_new" },
                            { label: "Aov khách mới", key: "aov_old" },
                        ]
                    }
                    userAdmin={userAdmin}
                />
                <Spin spinning={loading} tip="Đang tải...">
                    <Row>
                        <Col xs={12} md={12}>
                            <Row className="h-100">
                                <Col xs={6} md={3} className="mb-2">
                                    <Tag color="blue" className="w-100 p-2 h-100">
                                        <span className={styles.textTag3}>Tổng hoa hồng phục vụ: </span>
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <span className={styles.textTag}> </span>
                                            </div>
                                            <div className="ml-3">
                                                <span className={styles.textTag}>
                                                    {convertCurrency(totalComPv)}</span>
                                            </div>
                                        </div>
                                    </Tag>
                                </Col>
                                <Col xs={6} md={3}  className="mb-2">
                                    <Tag color="blue" className="w-100 p-2 h-100">
                                        <span className={styles.textTag3}>
                                            <Tooltip title='Tổng số tiền thu về từ hoạt động bán thẻ dịch vụ, dịch vụ, sản phẩm của công ty từ mọi nguồn gồm cả tiền thu nợ bằng các phương thức thanh toán chuyển khoản, tiền mặt, quẹt thẻ, sử dụng thẻ tiền, không bao gồm sử dụng điểm tích lũy.'>
                                                Thực thu bán hàng:  <i className="fas fa-info-circle"></i>
                                            </Tooltip>
                                        </span>
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <span className={styles.textTag}> </span>
                                            </div>
                                            <div className="ml-3">
                                                <span className={styles.textTag}>{convertCurrency(totalPaidTv)}</span>
                                            </div>
                                        </div>
                                        <span className={styles.textTag3}>
                                            Hoa hồng bán hàng:
                                        </span>
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <span className={styles.textTag}> </span>
                                            </div>
                                            <div className="ml-3">
                                                <span className={styles.textTag}>{convertCurrency(totalComTv)}</span>
                                            </div>
                                        </div>
                                    </Tag>
                                </Col>
                                <Col xs={6} md={3}  className="mb-2">
                                    <Tag color="blue" className="w-100 p-2 h-100">
                                        <span className={styles.textTag3}>Tỷ lệ chốt đơn: </span>
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <span  className={styles.textTag5}>
                                                    <Tooltip title='Tổng số lượng khách sử dụng dịch vụ'>
                                                        Tổng khách hàng phục vụ: <i className="fas fa-info-circle"></i>
                                                    </Tooltip>
                                                </span>
                                                <span  className={styles.textTag5}> 
                                                    <Tooltip title='Tổng số lượng khách mua dịch vụ'>
                                                        Tổng khách hàng tư vấn: <i className="fas fa-info-circle"></i>
                                                    </Tooltip>
                                                </span>
                                                <span className={styles.textTag5}> Tỷ lệ chốt:</span>
                                            </div>
                                            <div className="ml-3">
                                                <span className={styles.textTag}>{totalOrderPv}</span>
                                                <span className={styles.textTag}>{totalOrderTv}</span>
                                                <span className={styles.textTag}>{aov}%</span>

                                            </div>
                                        </div>
                                    </Tag>
                                </Col>                                
                            </Row>
                        </Col>
                        <Col xs={12}>
                            <div style={{ backgroundColor: "white" }}>
                                <div className="border-bottom w-100 p-2">
                                    Bảng số liệu chi tiết
                                </div>
                                <div style={{ height: 495, width: '100%' }} className="p-2">

                                    <Table 
                                        columns={columns} 
                                        dataSource={[...table]}
                                        pagination={{ pageSize: pageSize, showSizeChanger: true, pageSizeOptions: ['10', '15', '30', '50', '100'] }}
                                        scroll={{ x: columns.length*150, y: 600 }}
                                        onChange={handleChange}
                                        bordered
                                        rowKey="users_id"
                                    />
                                </div>

                            </div>
                        </Col>
                    </Row>
                </Spin>
            </div>
            {isView ?
                <PopupViewServices
                    show={isView}
                    close={handleIsView}
                    dataViewService={dataViewService}
                    detailComPv={detailComPv}
                    showSorterTooltip={{ title: '' }}
                />
            : null}
        </>
    )
}
export default ReportKtvTvvOffline